"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// fix underlying prices if a priceDiffer occurs.
// current solution: adjust the selected cabinCategory price
function handlePriceDiffer(_a, pricings) {
    // unpack the the API response
    //const pricings = getters['generalBookingError'].messages[0].services
    var getters = _a.getters, dispatch = _a.dispatch;
    // loop over pricings, rewrite all differs
    for (var _i = 0, pricings_1 = pricings; _i < pricings_1.length; _i++) {
        var pricing = pricings_1[_i];
        switch (pricing.type) {
            case 'CRU':
                dispatch('cabins/updateSelectedCabinCategoryPrice', pricing.price);
                break;
            case 'AIR':
                dispatch('transportAir/priceDiffer', pricing.price);
                break;
            case 'FLX':
                dispatch('transportFlexFlights/priceDiffer', pricing.price);
                break;
            case 'RIT':
                console.log('TODO: RIT price differ!');
                break;
            case 'INS':
                dispatch('insurance/updatePrice', pricing);
                break;
        }
        dispatch('checkoutSetPrice', {
            'fullprice': getters['totalPrice'],
            'insurancePrice': getters['insurance/totalPrice'],
            'priceModel': getters['generalCruise'].priceModel,
            'departure': getters['generalCruise'].departure
        });
    }
    // remove the API error - ! done in multi-cabins !
    // dispatch('generalSetBookError', null)
}
exports.default = handlePriceDiffer;
//# sourceMappingURL=handle_price_differ.js.map